<template>
  <!-- 患者検索 -->
  <div id="AppPatientSearchResult">
    <!-- 検索結果 -->
    <div class="columns">
      <div class="column" />
      <div class="column is-one-third">
        <b-field horizontal label="患者検索結果" style="float:right; white-space:nowrap;">
          <b-select position="is-right" v-model="perPage">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </b-select>
        </b-field>
      </div>
    </div>
    <div>
      <b-table
        :data="searchResult"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :pagination-size="paginationSize"
        :backend-sorting="true"
        @sort="sortPressed"
        v-on:page-change="sortPressed"
        detailed
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        @check-all="selectedAll"
        :checkable="multiSelectMode"
        :checked-rows.sync="checkedRows"
        checkbox-position="left"
      >
        <template slot-scope="props">
          <b-table-column v-if="selectMode && multiSelectMode == false" field="patientCode" label sortable centered>
            <b-radio v-model="selected" :native-value="props.row"></b-radio>
          </b-table-column>
          <b-table-column
            field="patientCode"
            label="患者コード"
            sortable
            centered
          >{{ props.row.patientCode }}</b-table-column>
          <b-table-column
            field="patientName"
            label="患者名"
            sortable
            centered
          >{{ props.row.patientName }}</b-table-column>
          <b-table-column field="patientNameKana" label="患者名（カナ）" sortable centered>
            <template v-if="props.row.patientNameKana">{{props.row.patientNameKana}}</template>
          </b-table-column>
          <b-table-column field="officeName" label="営業所" sortable centered>
            <span
              v-for="officeName in getOfficeName(props.row.officeName)"
              :value="officeName"
              :key="officeName"
            >
              {{ officeName}}
              <br />
            </span>
          </b-table-column>
          <b-table-column
            field="patientPhone"
            label="電話番号"
            sortable
            centered
          >{{ props.row.patientPhone }}</b-table-column>
          <b-table-column
            label="点検担当者"
            sortable
            centered
          >{{ props.row.staffName }}</b-table-column>
           <b-table-column
            field="therapy"
            label="療法"
            sortable
            centered
          >{{ props.row.therapy }}</b-table-column>
          <b-table-column
            field="emergencyLevel"
            label="緊急連絡レベル"
            sortable
            centered
          >{{ props.row.emergencyLevel | emergencyLevelFilter }}</b-table-column>

          <b-table-column field="files" label="添付" centered>
            <b-button
              v-if="props.row.files && props.row.files.length"
              class="button is-primary has-text-centered"
              icon-left="mdi mdi-paperclip"
              native-type="button"
              @click="showFiles(props.row.files)"
            ></b-button>
          </b-table-column>

          <b-table-column v-if="!patientDb.disable && selectMode!=true" field="configuration" label="対応記録" centered>
            <b-button
              class="button is-primary has-text-centered"
              icon-left="pencil"
              native-type="button"
              @click="gotoAppUrgentList(props.row)"
            ></b-button>
          </b-table-column>

          <b-table-column v-if="selectMode!=true" label="詳細" sortable centered>
            <b-button
              class="button is-primary has-text-centered"
              icon-left="mdi mdi-cog"
              native-type="button"
              v-on:click="refDetail(props.row.patientCode)"
            ></b-button>
          </b-table-column>
        </template>
        <template slot="detail" slot-scope="props">
          <div class="content">
            <span style="margin-left:10px; font-weight:bold; font-size:14px;">住所：</span>
            <span style="font-weight:bold; font-size:14px;">〒{{props.row.postCode}} {{ props.row.address }}</span>
            <div style="height: 10px;" />
            <table style="table-layout: fixed;">
              <template v-for="(prodItem, index) in props.row.productDetail">
                <tr v-bind:key="prodItem.index">
                  <th style="width: 150px;" rowspan="3">機器情報 {{index + 1}}</th>
                  <th style="width: 150px;">機器名</th>
                  <td>{{ prodItem.productName }} ({{ prodItem.productCode }})</td>
                </tr>
                <tr v-bind:key="prodItem.index">
                  <th>シリアルNo.</th>
                  <td>{{ prodItem.serialNumber }}</td>
                </tr>
                <tr v-bind:key="prodItem.index">
                  <th>医療機関名</th>
                  <td>{{ prodItem.hospitalName }} ({{ prodItem.hospitalCode }})</td>
                </tr>
              </template>
              <tr></tr>
            </table>
          </div>
        </template>
      </b-table>
    </div>

    <!-- 添付一覧 -->
    <files-modal v-model="isShowFiles" :files="selectedFiles" @download-file="downloadFile($event)"/>
  </div>
</template>

<script>
import orderBy from "lodash/orderBy";
import Files from "./common/Files.vue";
var officeMaster = [];
var isError = false;
export default {
  components: {
    "files-modal": Files,
  },

  props: ["selectMode", "isNationwide", "value", "searchConditions", "multiSelectMode"],
  name: "AppPatientSearchResult",
  methods: {
    selectedAll:function(rows){
      if (rows.length > this.checkedRows.length) {
        this.$nextTick(() => { this.checkedRows = this.value });
      } else {
        this.$nextTick(() => { this.checkedRows = [] });
      }
      return;
    },
    getOfficeName: function(value) {
      return value.split(",");
    },
    refDetail: function(code) {
      this.$router.push({
        name: "AppPatientDetail",
        params: {
          code: code,
          searchConditions: this.searchConditions
        }
      });
    },
    getSelectedItem: function() {
      // 選択項目取得
      return this.multiSelectMode ? this.checkedRows : this.selected;
    },
    sortPressed(field, order, event) {
      this.value = orderBy(this.searchResult, field, order);
    },

    showFiles: function (files) {
      this.selectedFiles = files;
      this.isShowFiles = true;
    },

    gotoAppUrgentList: function (row) {
      this.$router.push({
        name: "AppUrgentList",
        params: {
          patientCode: row.patientCode,
        },
      });
    },

    downloadFile: function(file) {
      this.targetFile = file;
      this.downloadS3ApiCall(this.getPatientFile, this.showErrorMessage, this.$store.state.subSystem);
      return;
    },

    getPatientFile: function(client) {
      const res = client.apis.apiPatient.getPatientFileGET({
        id: this.targetFile.id,
      }); 
      this.targetFile = null;
      return res;
    },
  },
  data() {
    officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    return {
      officeMaster,
      hasResult: false,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 10,
      selected: "",
      oldSelected: [],
      isNationwideSearch: this.$props.isNationwide,
      selectedFiles: null,
      isShowFiles: false,
      // 選択
      checkedRows: [],
      targetFile: null,
      patientDb: userInfo.system.patientDb,
    };
  },
  mounted: function() {
  },
  filters: {
    officeFilter: function(value) {
      var officeElement = officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.officeName;
      }
      return "";
    },
    emergencyLevelFilter: function(value) {
      switch(value){
        case "1":
          return "S : NPPV 24h（マスク）"
        case "2":
          return "A : TPPV 24h（気切）"
        case "3":
          return "B : TPPV 夜間のみ（気切）"
        case "4":
          return "C : NPPV 夜間のみ（マスク）"
        case "5":
          return "D：HOT24h（設定値３L以上）"
        case "6":
          return "E：HOT24h（設定値３L未満）"
        default:
          return "";
      }
    }
  },
  computed: {
    searchResult() {
      return this.value;
    }
  },
  watch: {
    selected: function(val) {
      this.selected = val;
    }
  },
  mounted: function() {}
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppPatientSearchResult.vue